var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"title":_vm.title,"width":_vm.width,"height":_vm.height,"BorderRadius":_vm.borderRadius}},[_c('v-col',{attrs:{"cols":"12"}},[_c('CardTitle',[_vm._v(_vm._s(_vm.title.toUpperCase()))]),_vm._t("icon")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }